export class AcceptRatingMail {
    Email: string;
    CustomerName: string;
    CustomerId: number;
    CustomerType: boolean; //False is 'Anonymous', True is 'Registered'
    StoreViewId: number;
    StoreViewName: string;
    LangCode: string;
    IsAccepted: boolean;
}